import { IRootState } from '../../../store'
import { IPcrSummaries } from '../store/home.types'

export const getPCRDocsSelector = (state: IRootState): IPcrSummaries => state.home.pcrDocs
